exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-panel-assets[data-v-3112fa74]{max-height:450px;overflow-y:auto}", ""]);

// exports
